import { Deal, RoomType } from "../types/deal";

export function totalRooms(types: RoomType[] | undefined): number {
  if (!Array.isArray(types)) return 0;
  return types.reduce((s, r) => s + (Number(r.rooms) || 0), 0);
}

export function totalRoomsFromMix(mix: any[] | undefined): number {
  if (!Array.isArray(mix) || mix.length === 0) return 0;

  return mix.reduce((total, item) => {
    const rooms =
      Number(item.rooms) ||
      Number(item.count) ||
      Number(item.roomCount) ||
      Number(item.total_rooms) ||
      Number(item.quantity) ||
      0;

    return total + rooms;
  }, 0);
}

export function getTotalRooms(deal: Deal): number {
  if (!deal) return 0;

  if (deal.kpis?.roomMix && Array.isArray(deal.kpis.roomMix)) {
    const total = deal.kpis.roomMix.reduce(
      (sum: number, r: any) => sum + (Number(r.rooms) || Number(r.count) || 0),
      0,
    );
    if (total > 0) return total;
  }

  if (deal.kpis?.rooms?.total && typeof deal.kpis.rooms.total === "number") {
    return deal.kpis.rooms.total;
  }

  if (deal.kpis?.roomsTotal && typeof deal.kpis.roomsTotal === "number") {
    return deal.kpis.roomsTotal;
  }

  if (deal.totalRooms && typeof deal.totalRooms === "number") {
    return deal.totalRooms;
  }

  return 0;
}

export function adrByType(overallAdr: number, weightIndex: number) {
  return overallAdr * (weightIndex / 100);
}

export function getRoomsTotal(list: Array<{ rooms?: number }>): number {
  return (list ?? []).reduce((s, r) => s + (Number(r?.rooms) || 0), 0);
}

export function isRoomMixValid(
  list: Array<{ name?: string; rooms?: number }>,
): { ok: boolean; total: number } {
  if (!Array.isArray(list)) return { ok: false, total: 0 };
  const total = getRoomsTotal(list);
  const allRowsValid = list.every(
    (r) =>
      (r?.name ?? "").toString().trim().length > 0 ||
      (Number(r?.rooms) || 0) > 0,
  );
  const noNegatives = list.every((r) => (Number(r?.rooms) || 0) >= 0);
  return { ok: allRowsValid && noNegatives && total > 0, total };
}
